import { createPropertySelectors } from '@ngxs/store';
import { ChallengesState, ChallengesStateModel } from './challenges.state';

export class ChallengesSelectors {
  static challenges = createPropertySelectors<ChallengesStateModel>(ChallengesState);
  static history = ChallengesSelectors.challenges.history;
  static isLoading = ChallengesSelectors.challenges.isLoading;
  static initialValue = ChallengesSelectors.challenges.initialValue;
}
